import type { TranslationDict } from '../en';

const id: TranslationDict = {
  'header.buy': 'Beli',
  'header.sell': 'Jual',
  'spend.label': 'Anda bayar',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Anda terima',
  'payment.label': 'Metode pembayaran',
  'payment.select': 'Pilih',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Tidak ada metode pembayaran untuk pasangan ini',
  'wallet.label': 'Alamat dompet penerima',
  'wallet.placeholderBuy': 'Masukkan alamat penerima Anda',
  'wallet.placeholderSell': 'Masukkan alamat pengirim Anda',
  'wallet.validating': 'Memvalidasi alamat...',
  'wallet.invalid': 'Masukkan alamat dompet yang valid',
  'wallet.invalidServer': 'Alamat dompet tidak valid',
  'cta.buy': 'Beli {crypto}',
  'cta.sell': 'Jual {crypto}',
  'cta.gettingPrice': 'Mencari harga terbaik...',
  'cta.processing': 'Memproses...',
  'footer.poweredBy': 'Didukung oleh ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Rincian kurs',
  'rate.close': 'Tutup',
  'rate.updatesIn': 'Kurs diperbarui dalam 00:{seconds}',
  'rate.noQuote': 'Tidak ada penawaran tersedia',
  'rate.exchangeRate': 'Kurs tukar',
  'rate.processingFee': 'Biaya pemrosesan',
  'rate.networkFee': 'Biaya jaringan',
  'rate.provider': 'Penyedia',
  'toast.orderCreated': 'Pesanan dibuat',
  'toast.redirecting': 'Mengalihkan ke checkout...',
  'toast.orderFailed': 'Pesanan gagal',
  'toast.couldNotCreate': 'Tidak dapat membuat pesanan',
  'toast.quoteError': 'Kesalahan penawaran',
  'toast.noProviders': 'Tidak ada penyedia',
  'toast.somethingWrong': 'Terjadi kesalahan',
  'error.amountZero': 'Jumlah harus lebih dari 0',
  'error.minAmountFiat': 'Jumlah minimum adalah {min} {currency}',
  'error.minAmountCrypto': 'Jumlah minimum adalah {min} {currency}',
  'error.noProviders': 'Tidak ada penyedia tersedia untuk kombinasi ini',
  'error.currencyUnavailableBuy': 'Mata uang ini tidak tersedia untuk pembelian',
  'error.currencyUnavailableSell': 'Mata uang ini tidak tersedia untuk penjualan',
  'parity.info': 'Anda akan dikenakan biaya untuk {receiveAmount} {crypto}, sisanya hingga {spendAmount} {fiat} akan dikreditkan ke akun {partner} Anda',
  'redirect.secureBadge': 'Pembayaran aman',
  'redirect.title': 'Lanjutkan Pembayaran',
  'redirect.description': 'Anda akan dialihkan ke {gateway} untuk menyelesaikan pembayaran.',
  'redirect.countdown': 'Mengalihkan dalam {seconds}...',
  'redirect.openTab': 'Buka ACH di tab baru',
  'redirect.cancel': 'Batal',
  'checkout.noOrder': 'Pesanan tidak ditemukan',
  'checkout.goBack': 'Kembali',
  'checkout.expired': 'Checkout kedaluwarsa',
  'checkout.expiredDesc': 'Sesi telah kedaluwarsa. Silakan coba lagi.',
  'checkout.startOver': 'Mulai ulang',
  'checkout.cancel': 'Batal',
  'checkout.loading': 'Memuat checkout...',
  'checkout.iframeTitle': 'Checkout Penyedia',
  'checkout.widgetTitle': 'Checkout Pembayaran',
  'checkout.unknownMethod': 'Metode checkout tidak dikenal',
  'processing.default': 'Memproses pesanan Anda...',
  'processing.pending': 'Menunggu konfirmasi pembayaran...',
  'processing.active': 'Memproses transaksi Anda...',
  'processing.generic': 'Memproses...',
  'processing.checkingStatus': 'Memeriksa status...',
  'processing.orderId': 'ID Pesanan',
  'processing.provider': 'Penyedia',
  'processing.amount': 'Jumlah',
  'processing.receiving': 'Menerima',
  'processing.network': 'Jaringan',
  'processing.toAddress': 'Ke Alamat',
  'processing.usuallyMinutes': 'Ini biasanya memakan waktu beberapa menit.',
  'processing.safeToClose': 'Anda dapat menutup halaman ini dengan aman - kami akan mengirim email saat selesai.',
  'complete.buyTitle': 'Pembelian Selesai!',
  'complete.sellTitle': 'Penjualan Selesai!',
  'complete.buyDesc': '{crypto} Anda telah dikirim ke dompet Anda.',
  'complete.sellDesc': 'Pembayaran {fiat} Anda sedang diproses.',
  'complete.amountBuy': 'Jumlah Diterima',
  'complete.amountSell': 'Jumlah Dijual',
  'complete.paidBuy': 'Jumlah Dibayar',
  'complete.paidSell': 'Jumlah Pembayaran',
  'complete.network': 'Jaringan',
  'complete.wallet': 'Dompet',
  'complete.transaction': 'Transaksi',
  'complete.provider': 'Penyedia',
  'complete.orderId': 'ID Pesanan',
  'complete.completed': 'Selesai',
  'complete.viewExplorer': 'Lihat di Explorer',
  'complete.done': 'Selesai',
  'errorStep.failed': 'Pembayaran Gagal',
  'errorStep.cancelled': 'Pesanan Dibatalkan',
  'errorStep.expired': 'Pesanan Kedaluwarsa',
  'errorStep.refunded': 'Pesanan Dikembalikan',
  'errorStep.unknown': 'Terjadi Kesalahan',
  'errorStep.failedBuy': 'Pembayaran Anda tidak dapat diproses. Silakan coba lagi atau gunakan metode pembayaran lain.',
  'errorStep.failedSell': 'Penjualan Anda tidak dapat diproses. Silakan coba lagi.',
  'errorStep.cancelledBuy': 'Pesanan Anda dibatalkan. Tidak ada pembayaran yang diproses.',
  'errorStep.cancelledSell': 'Penjualan Anda dibatalkan. Tidak ada kripto yang ditransfer.',
  'errorStep.expiredBuy': 'Pesanan Anda telah kedaluwarsa. Silakan mulai pembelian baru.',
  'errorStep.expiredSell': 'Pesanan Anda telah kedaluwarsa. Silakan mulai penjualan baru.',
  'errorStep.refundedBuy': 'Pembayaran Anda telah dikembalikan. Dana akan muncul di akun Anda dalam 5-10 hari kerja.',
  'errorStep.refundedSell': 'Kripto Anda telah dikembalikan. Dana akan muncul di dompet Anda segera.',
  'errorStep.genericDesc': 'Terjadi kesalahan yang tidak terduga. Silakan coba lagi.',
  'errorStep.orderId': 'ID Pesanan',
  'errorStep.tryAgain': 'Coba Lagi',
  'errorStep.startOver': 'Mulai Ulang',
  'errorStep.return': 'Kembali',
  'errorStep.needHelp': 'Butuh bantuan? Hubungi ',
  'errorStep.reference': 'Referensi: {orderId}',
  'confirm.buyTitle': 'Konfirmasi Pembelian',
  'confirm.sellTitle': 'Konfirmasi Penjualan',
  'confirm.loading': 'Memuat...',
  'confirm.provider': 'Penyedia',
  'confirm.youPay': 'Anda bayar',
  'confirm.youSell': 'Anda jual',
  'confirm.youReceive': 'Anda terima',
  'confirm.wallet': 'Dompet',
  'confirm.network': 'Jaringan',
  'confirm.refundAddress': 'Alamat pengembalian',
  'confirm.parityNote': 'Jumlah yang dikenakan oleh penyedia mungkin berbeda. Sisanya hingga {amount} {crypto} akan dikreditkan ke akun {partner} Anda.',
  'confirm.processing': 'Memproses...',
  'confirm.confirmPay': 'Konfirmasi & Bayar',
  'confirm.confirmSell': 'Konfirmasi & Jual',
  'confirm.payout': 'Pembayaran {currency}',
  'modal.selectFiat': 'Pilih mata uang fiat',
  'modal.selectCrypto': 'Pilih mata uang kripto',
  'modal.choosePayment': 'Pilih metode pembayaran',
  'modal.selectCountry': 'Pilih negara Anda',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Populer',
  'modal.recommended': 'Direkomendasikan',
  'modal.noCurrencies': 'Tidak ada mata uang ditemukan',
  'modal.noPaymentMethods': 'Tidak ada metode pembayaran ditemukan',
  'modal.noCountries': 'Tidak ada negara ditemukan',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Lokasi',
  'settings.darkMode': 'Mode Gelap',
  'settings.privacy': 'Kebijakan privasi',
  'settings.terms': 'Ketentuan penggunaan',
  'settings.language': 'Bahasa',
  // ─── Additional ───
  'modal.chooseRamp': 'Pilih Ramp',
  'modal.bestPrice': 'Harga terbaik',
  'modal.noQuotes': 'Tidak ada penawaran untuk permintaan ini',
  'modal.noProvidersFound': 'Tidak ada penyedia ditemukan',
  'payment.unavailableFor': 'Tidak ada metode pembayaran untuk {currency}',
  'skeleton.poweredBy': 'Didukung oleh NowRamp',
  'error.createOrderFailed': 'Gagal membuat pesanan',
  'errorStep.returnToMerchant': 'Kembali ke merchant',
  'confirm.cryptoOnNetwork': '{crypto} di {network}',
  'payment.name.card': 'Kartu',
  'payment.name.bankTransfer': 'Transfer Bank',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default id;
